var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-scroll",
      staticStyle: { width: "100%", height: "100%", overflow: "auto" }
    },
    [
      _c("top"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "background-color": "#f5f5f5",
            "min-height": "calc(100% - 410px)"
          }
        },
        [
          _c(
            "div",
            { staticClass: "contain-box", staticStyle: { padding: "35px 0" } },
            [_c("router-view")],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("foot"),
      _vm._v(" "),
      _c("el-backtop", { attrs: { target: ".page-scroll", bottom: 100 } }, [
        _c(
          "div",
          {
            staticStyle: {
              "{\n      height": "100%",
              width: "100%",
              "background-color": "#f2f5f6",
              "box-shadow": "0 0 6px rgba(0,0,0, .12)",
              "text-align": "center",
              "line-height": "40px",
              color: "#1989fa"
            }
          },
          [_vm._v("\n      UP\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-879d38ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879d38ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay/layout.vue
// module id = null
// module chunks = 